module.exports = __webpack_public_path__ + "img/bg_2.65f73470.jpg";